import { useState } from "react";

import { Select } from "components/ui/Select/Select";

import { useEmailTemplates } from "../../hooks/useEmailTemplates";
import styles from "./ChooseEmailTemplateModal.module.css";

export const ChooseEmailTemplateModal = ({
  onSelect,
  isOpen: parentIsOpen,
  patientId,
  consultationId,
}) => {
  const [selectedId, setSelectedId] = useState("");
  const { data: templates = [], isLoading } = useEmailTemplates(
    parentIsOpen,
    patientId,
    consultationId
  );

  const options = templates.map((template) => ({
    label: template.name,
    value: String(template.id),
  }));

  const handleChange = (value) => {
    setSelectedId(value);

    if (!value) return;

    const template = templates.find((t) => String(t.id) === value);

    if (!template) return;

    onSelect?.(template);
  };

  return (
    <div className={styles.container}>
      <label className={styles.pickerLabel}>Select template</label>
      <Select
        options={options}
        value={selectedId}
        onChange={handleChange}
        disabled={isLoading}
        placeholder={isLoading ? "Loading templates..." : "Select Template"}
        fullWidth
      />
    </div>
  );
};
